export const HolidayTableHeaders = [
  "holiday-from",
  "holiday-to",
  "",
  "modify",
  "delete",
];
